/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { SuccessMsg } from '../models';
/**
 * FairplayApiApi - axios parameter creator
 */
export const FairplayApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [competitionId] 
         * @param {string} [questionId] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fairplayApiFetchUserFairplayScores: async (competitionId?: string, questionId?: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fairplay/scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (competitionId !== undefined) {
                localVarQueryParameter['competition_id'] = competitionId;
            }

            if (questionId !== undefined) {
                localVarQueryParameter['question_id'] = questionId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {boolean} [forceReset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fairplayApiSyncFairplayBonuses: async (competitionId: string, forceReset?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('fairplayApiSyncFairplayBonuses', 'competitionId', competitionId)
            const localVarPath = `/admin/competition/{competition_id}/fairplay-bonuses`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (forceReset !== undefined) {
                localVarQueryParameter['force_reset'] = forceReset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FairplayApiApi - functional programming interface
 */
export const FairplayApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FairplayApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [competitionId] 
         * @param {string} [questionId] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fairplayApiFetchUserFairplayScores(competitionId?: string, questionId?: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fairplayApiFetchUserFairplayScores(competitionId, questionId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FairplayApiApi.fairplayApiFetchUserFairplayScores']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {boolean} [forceReset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fairplayApiSyncFairplayBonuses(competitionId: string, forceReset?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMsg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fairplayApiSyncFairplayBonuses(competitionId, forceReset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FairplayApiApi.fairplayApiSyncFairplayBonuses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FairplayApiApi - factory interface
 */
export const FairplayApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FairplayApiApiFp(configuration)
    return {
        /**
         * 
         * @param {FairplayApiApiFairplayApiFetchUserFairplayScoresRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fairplayApiFetchUserFairplayScores(requestParameters: FairplayApiApiFairplayApiFetchUserFairplayScoresRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.fairplayApiFetchUserFairplayScores(requestParameters.competitionId, requestParameters.questionId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FairplayApiApiFairplayApiSyncFairplayBonusesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fairplayApiSyncFairplayBonuses(requestParameters: FairplayApiApiFairplayApiSyncFairplayBonusesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMsg> {
            return localVarFp.fairplayApiSyncFairplayBonuses(requestParameters.competitionId, requestParameters.forceReset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for fairplayApiFetchUserFairplayScores operation in FairplayApiApi.
 */
export interface FairplayApiApiFairplayApiFetchUserFairplayScoresRequest {
    readonly competitionId?: string

    readonly questionId?: string

    readonly userId?: string
}

/**
 * Request parameters for fairplayApiSyncFairplayBonuses operation in FairplayApiApi.
 */
export interface FairplayApiApiFairplayApiSyncFairplayBonusesRequest {
    readonly competitionId: string

    readonly forceReset?: boolean
}

/**
 * FairplayApiApi - object-oriented interface
 */
export class FairplayApiApi extends BaseAPI {
    /**
     * 
     * @param {FairplayApiApiFairplayApiFetchUserFairplayScoresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fairplayApiFetchUserFairplayScores(requestParameters: FairplayApiApiFairplayApiFetchUserFairplayScoresRequest = {}, options?: RawAxiosRequestConfig) {
        return FairplayApiApiFp(this.configuration).fairplayApiFetchUserFairplayScores(requestParameters.competitionId, requestParameters.questionId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FairplayApiApiFairplayApiSyncFairplayBonusesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fairplayApiSyncFairplayBonuses(requestParameters: FairplayApiApiFairplayApiSyncFairplayBonusesRequest, options?: RawAxiosRequestConfig) {
        return FairplayApiApiFp(this.configuration).fairplayApiSyncFairplayBonuses(requestParameters.competitionId, requestParameters.forceReset, options).then((request) => request(this.axios, this.basePath));
    }
}

